import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

import SOUNDS from 'sounds'

export const RESERVE_ACTIVATION_REQUEST = 'reserve_activation/REQUEST'
export const RESERVE_ACTIVATION_SUCCESS = 'reserve_activation/SUCCESS'
export const RESERVE_ACTIVATION_ERROR = 'reserve_activation/ERROR'

export function startReserveActivationRequest() {
    return {
        type: RESERVE_ACTIVATION_REQUEST,
        payload: {},
    }
}

export function reserveActivationSuccess(resp) {
    const { reserves } = resp
    return {
        type: RESERVE_ACTIVATION_SUCCESS,
        payload: {
            reserves,
        },
        meta: {
            webToClient: {
                handler: 'playSound',
                params: { soundId: SOUNDS.RESERVE_ACTIVATION },
            },
        },
    }
}

export function reserveActivationError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: RESERVE_ACTIVATION_ERROR,
        payload: errorData,
    }
}

export default function activateReserve(reserveId) {
    return async (dispatch, getState) => {
        const { reserveActivation } = getState()
        if (reserveActivation.submitting) {
            return
        }
        dispatch(startReserveActivationRequest())

        const url = `/game_api/reserves/${reserveId}/activate`
        httpRequest(url, 'PATCH').then(
            resp => dispatch(reserveActivationSuccess(resp)),
            errorData => dispatch(reserveActivationError(errorData))
        )
    }
}



// WEBPACK FOOTER //
// ./state/actions/reserve_activation.js